export enum BomTreeNodeType {
    Material = 1,
    ProductionNode,
    ReplacementNode,
    AlternativeBomNode,
    MaintenanceNode,
    AlternativeItemsNode,
    RecommendedItemsNode
}